import { BaseService } from '@services/BaseService'

const resource = 'hr/supplement'

class SupplementService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const supplementService = new SupplementService()
